import { useLocation } from "react-router-dom";
import { useLanguage } from "@/hooks/useLanguage";
import { helpNavigationSearch } from "@/config/helpNavigationContext";

/** "SV / EN" as text links to the same page in the other language. */
export function LanguageLinks() {
  const location = useLocation();
  const { language, getAlternateLink } = useLanguage();
  const other = getAlternateLink(location.pathname);
  const context = helpNavigationSearch(location.pathname, location.search);
  const links = [
    { lang: "sv", label: "SV", name: "Svenska" },
    { lang: "en", label: "EN", name: "English" },
  ] as const;
  return (
    <div
      className="flex items-center text-sm font-semibold text-slate"
      role="group"
      aria-label={language === "sv" ? "Språk" : "Language"}
    >
      {links.map((link, index) => {
        const current = link.lang === language;
        return (
          <span key={link.lang} className="flex items-center">
            {index > 0 && <span aria-hidden="true">/</span>}
            <a
              href={`${current ? location.pathname : other}${context}`}
              hrefLang={link.lang}
              lang={link.lang}
              title={link.name}
              aria-current={current ? "page" : undefined}
              className={`inline-flex min-h-11 min-w-9 items-center justify-center rounded-md px-1.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-caire-action ${current ? "text-caire-ink underline underline-offset-4" : "hover:text-caire-ink"}`}
            >
              {link.label}
            </a>
          </span>
        );
      })}
    </div>
  );
}
